// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!./AssessmentDefaults.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AssessmentForm_dialog__Af\\+Dw {
  width: calc(100vw - 20px);
  height: calc(100vh - 20px);
  max-width: 1000px;
}

.AssessmentForm_mainLayout__ipjUr {
  display: grid;
  grid-template-areas:
    "instruction"
    "outcomesHeader"
    "outcomes"
    "formHeader"
    "form";
  width: 100%;
  height: 100%;
  gap: 5px;
}

.AssessmentForm_mainLayoutInstruction__F3kgK {
  grid-area: instruction;
  background: #f3eff8;
  border-radius: 10px;
  padding: 20px;
  white-space: pre-line;
}

.AssessmentForm_mainLayoutOutcomesHeader__ZwmqW {
  grid-area: outcomesHeader;
  font-weight: 600;
  font-size: large;
  margin-bottom: 5px;
}

.AssessmentForm_mainLayoutOutcomes__lzhQU {
  grid-area: outcomes;
}

.AssessmentForm_mainLayoutFormHeader__Vvmp2 {
  grid-area: formHeader;
  font-weight: 600;
  font-size: large;
  margin-top: 20px;
  margin-bottom: 5px;
}

.AssessmentForm_mainLayoutForm__oExfN {
  grid-area: form;
}

.AssessmentForm_form__Y4rjx {
  height: 100%;
}

.AssessmentForm_formLayout__Wj\\+Pj {
  display: grid;
  grid-template-areas:
    "body"
    "footer";
  width: 100%;
  height: 100%;
  border-radius: 10px;
}

.AssessmentForm_formLayoutBody__7FrRX {
  grid-area: body;
  overflow: auto;
  padding: 20px;
  background: #f3eff8;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.AssessmentForm_formLayoutFooter__YThB3 {
  grid-area: footer;
  padding: 20px;
  padding-top: 0px;
  background: #f3eff8;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-bottom: 20px;
}

.AssessmentForm_buttonContainer__5nQJr {
  display: flex;
  flex-direction: row-reverse;
  gap: 5px;
}

.AssessmentForm_outcomeOnlyLayout__9h-Oi {
  display: grid;
  grid-template-areas:
    "instruction"
    "outcomes";
  grid-template-rows: minmax(0, min-content) auto;
  width: calc(100% - 10px);
  height: 100%;
}

.AssessmentForm_outcomeOnly__Tzof- {
  height: 100%;
}

.AssessmentForm_outcomeLayout__b9vca {
  display: grid;
  grid-template-areas:
    "score"
    "outcomeHeader"
    "outcomes"
    "remarksHeader"
    "remarks"
    "footer";
  grid-template-rows: 70px 25px min-content 25px auto 50px;
  width: calc(100% - 10px);
  height: 100%;
  grid-gap: 5px;
  padding-left: 10px;
  padding-right: 10px;
  margin-right: 20px;
  border-radius: 10px;
  background-color: #f3eff8;
}

.AssessmentForm_outcomeCompletedLayout__DQJUH {
  display: grid;
  grid-template-areas:
    "score"
    "outcomeHeader"
    "outcomes"
    "remarksHeader"
    "remarks";
  width: 100%;
  grid-gap: 5px;
  padding: 20px;
  border-radius: 10px;
  background-color: #f3eff8;
}

.AssessmentForm_outcomeLayoutScore__fYFqO {
  grid-area: score;
  font-weight: 600;
  padding-right: 5px;
}

.AssessmentForm_outcomeLayoutOutcomeHeader__hY3rx {
  grid-area: outcomeHeader;
  font-weight: 600;
  margin-top: 20px;
}

.AssessmentForm_outcomeLayoutOutcomes__gFimw {
  grid-area: outcomes;
}

.AssessmentForm_outcomeLayoutRemarksHeader__g5osM {
  grid-area: remarksHeader;
  font-weight: 600;
  margin-top: 20px;
}

.AssessmentForm_outcomeLayoutRemarks__fJ\\+Ww {
  grid-area: remarks;
}

.AssessmentForm_outcomeLayoutFooter__VbTlv {
  grid-area: footer;
  display: flex;
  justify-content: flex-end;
  padding-bottom: 10px;
}

.AssessmentForm_outcomeInput__tNJqf {
  width: 100%;
  height: 100%;
}

.AssessmentForm_outcomeOptionLayout__bpt0d {
  display: grid;
  grid-template-areas: "checkbox title";
  grid-template-columns: 30px auto;
  grid-gap: 5px;
  width: calc(100% - 10px);
  height: 40px;
  margin-top: 5px;
  margin-left: 10px;
  padding-left: 10px;
  background-color: white;
}

.AssessmentForm_outcomeOptionLayoutCheckbox__lxl1k {
  grid-area: checkbox;
  display: flex;
  align-items: center;
}

.AssessmentForm_outcomeOptionLayoutTitle__vUXKw {
  grid-area: title;
  display: flex;
  align-items: center;
}

.AssessmentForm_noMarginButton__tUpI1 {
  margin: 0px;
}

.AssessmentForm_ReadOnlyTextContainer__gAOZn {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 5px;
  padding-left: 10px;
  margin-top: 10px;
}

.AssessmentForm_readOnlyOutcome__dvYCt {
  width: calc(100% - 5px);
}

.AssessmentForm_scoreText__uUg1P {
  color: var(--branded-purple);
  font-weight: normal;
}

.AssessmentForm_scoreTextError__2JMad {
  color: red;
}

.AssessmentForm_scoreTextErrorDiv__i4-tB {
  color: red;
  font-size: small;
}

.AssessmentForm_submitLayout__35GJK {
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-top: 20vh;
}

.AssessmentForm_submitLayoutDescription__Un8Pk {
  grid-area: description;
}

.AssessmentForm_submitLayoutLoader__0wCsd {
  grid-area: loader;
}

.AssessmentForm_matrixQuestionTable__OZJCq {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.AssessmentForm_matrixQuestionTable__OZJCq thead tr th:nth-of-type(2) {
  border-top-left-radius: 10px !important;
}

.AssessmentForm_matrixQuestionTable__OZJCq thead tr th:last-of-type {
  border-top-right-radius: 10px !important;
}

.AssessmentForm_matrixQuestionTable__OZJCq tr:first-of-type td:first-of-type {
  border-top-left-radius: 10px !important;
}

.AssessmentForm_matrixQuestionTable__OZJCq tr:last-of-type td:first-of-type {
  border-bottom-left-radius: 10px !important;
}

.AssessmentForm_matrixQuestionTable__OZJCq tr:last-of-type td:last-of-type {
  border-bottom-right-radius: 10px !important;
}

.AssessmentForm_matrixQuestionOptionHeader__4e6Qb {
  padding: 10px;
  background-color: var(--lightPurple);
  border: 1px solid #e7e0f1;
  font-weight: 400;
}

.AssessmentForm_matrixQuestionOptionTextColumn__oB3B6 {
  background-color: var(--lightPurple);
  border: 1px solid var(--stroke, #e7e0f1);
  font-weight: 400;
  padding: 10px;
}

.AssessmentForm_matrixQuestionOptionColumn__RQk2w {
  width: auto;
  border: 1px solid var(--stroke, #e7e0f1);
}

.AssessmentForm_matrixQuestionOption__C5aWc {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.AssessmentForm_matrixQuestionOptionRadio__8E2yW {
  margin-bottom: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/assessments/AssessmentForm.module.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb;;;;;UAKQ;EACR,WAAW;EACX,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb;;YAEU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb;;cAEY;EACZ,+CAA+C;EAC/C,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb;;;;;;YAMU;EACV,wDAAwD;EACxD,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb;;;;;aAKW;EACX,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gCAAgC;EAChC,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["@import \"./AssessmentDefaults.css\";\n\n.dialog {\n  width: calc(100vw - 20px);\n  height: calc(100vh - 20px);\n  max-width: 1000px;\n}\n\n.mainLayout {\n  display: grid;\n  grid-template-areas:\n    \"instruction\"\n    \"outcomesHeader\"\n    \"outcomes\"\n    \"formHeader\"\n    \"form\";\n  width: 100%;\n  height: 100%;\n  gap: 5px;\n}\n\n.mainLayoutInstruction {\n  grid-area: instruction;\n  background: #f3eff8;\n  border-radius: 10px;\n  padding: 20px;\n  white-space: pre-line;\n}\n\n.mainLayoutOutcomesHeader {\n  grid-area: outcomesHeader;\n  font-weight: 600;\n  font-size: large;\n  margin-bottom: 5px;\n}\n\n.mainLayoutOutcomes {\n  grid-area: outcomes;\n}\n\n.mainLayoutFormHeader {\n  grid-area: formHeader;\n  font-weight: 600;\n  font-size: large;\n  margin-top: 20px;\n  margin-bottom: 5px;\n}\n\n.mainLayoutForm {\n  grid-area: form;\n}\n\n.form {\n  height: 100%;\n}\n\n.formLayout {\n  display: grid;\n  grid-template-areas:\n    \"body\"\n    \"footer\";\n  width: 100%;\n  height: 100%;\n  border-radius: 10px;\n}\n\n.formLayoutBody {\n  grid-area: body;\n  overflow: auto;\n  padding: 20px;\n  background: #f3eff8;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.formLayoutFooter {\n  grid-area: footer;\n  padding: 20px;\n  padding-top: 0px;\n  background: #f3eff8;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  margin-bottom: 20px;\n}\n\n.buttonContainer {\n  display: flex;\n  flex-direction: row-reverse;\n  gap: 5px;\n}\n\n.outcomeOnlyLayout {\n  display: grid;\n  grid-template-areas:\n    \"instruction\"\n    \"outcomes\";\n  grid-template-rows: minmax(0, min-content) auto;\n  width: calc(100% - 10px);\n  height: 100%;\n}\n\n.outcomeOnly {\n  height: 100%;\n}\n\n.outcomeLayout {\n  display: grid;\n  grid-template-areas:\n    \"score\"\n    \"outcomeHeader\"\n    \"outcomes\"\n    \"remarksHeader\"\n    \"remarks\"\n    \"footer\";\n  grid-template-rows: 70px 25px min-content 25px auto 50px;\n  width: calc(100% - 10px);\n  height: 100%;\n  grid-gap: 5px;\n  padding-left: 10px;\n  padding-right: 10px;\n  margin-right: 20px;\n  border-radius: 10px;\n  background-color: #f3eff8;\n}\n\n.outcomeCompletedLayout {\n  display: grid;\n  grid-template-areas:\n    \"score\"\n    \"outcomeHeader\"\n    \"outcomes\"\n    \"remarksHeader\"\n    \"remarks\";\n  width: 100%;\n  grid-gap: 5px;\n  padding: 20px;\n  border-radius: 10px;\n  background-color: #f3eff8;\n}\n\n.outcomeLayoutScore {\n  grid-area: score;\n  font-weight: 600;\n  padding-right: 5px;\n}\n\n.outcomeLayoutOutcomeHeader {\n  grid-area: outcomeHeader;\n  font-weight: 600;\n  margin-top: 20px;\n}\n\n.outcomeLayoutOutcomes {\n  grid-area: outcomes;\n}\n\n.outcomeLayoutRemarksHeader {\n  grid-area: remarksHeader;\n  font-weight: 600;\n  margin-top: 20px;\n}\n\n.outcomeLayoutRemarks {\n  grid-area: remarks;\n}\n\n.outcomeLayoutFooter {\n  grid-area: footer;\n  display: flex;\n  justify-content: flex-end;\n  padding-bottom: 10px;\n}\n\n.outcomeInput {\n  width: 100%;\n  height: 100%;\n}\n\n.outcomeOptionLayout {\n  display: grid;\n  grid-template-areas: \"checkbox title\";\n  grid-template-columns: 30px auto;\n  grid-gap: 5px;\n  width: calc(100% - 10px);\n  height: 40px;\n  margin-top: 5px;\n  margin-left: 10px;\n  padding-left: 10px;\n  background-color: white;\n}\n\n.outcomeOptionLayoutCheckbox {\n  grid-area: checkbox;\n  display: flex;\n  align-items: center;\n}\n\n.outcomeOptionLayoutTitle {\n  grid-area: title;\n  display: flex;\n  align-items: center;\n}\n\n.noMarginButton {\n  margin: 0px;\n}\n\n.ReadOnlyTextContainer {\n  width: 100%;\n  background-color: white;\n  border-radius: 5px;\n  padding: 5px;\n  padding-left: 10px;\n  margin-top: 10px;\n}\n\n.readOnlyOutcome {\n  width: calc(100% - 5px);\n}\n\n.scoreText {\n  color: var(--branded-purple);\n  font-weight: normal;\n}\n\n.scoreTextError {\n  color: red;\n}\n\n.scoreTextErrorDiv {\n  color: red;\n  font-size: small;\n}\n\n.submitLayout {\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  padding-top: 20vh;\n}\n\n.submitLayoutDescription {\n  grid-area: description;\n}\n\n.submitLayoutLoader {\n  grid-area: loader;\n}\n\n.matrixQuestionTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.matrixQuestionTable thead tr th:nth-of-type(2) {\n  border-top-left-radius: 10px !important;\n}\n\n.matrixQuestionTable thead tr th:last-of-type {\n  border-top-right-radius: 10px !important;\n}\n\n.matrixQuestionTable tr:first-of-type td:first-of-type {\n  border-top-left-radius: 10px !important;\n}\n\n.matrixQuestionTable tr:last-of-type td:first-of-type {\n  border-bottom-left-radius: 10px !important;\n}\n\n.matrixQuestionTable tr:last-of-type td:last-of-type {\n  border-bottom-right-radius: 10px !important;\n}\n\n.matrixQuestionOptionHeader {\n  padding: 10px;\n  background-color: var(--lightPurple);\n  border: 1px solid #e7e0f1;\n  font-weight: 400;\n}\n\n.matrixQuestionOptionTextColumn {\n  background-color: var(--lightPurple);\n  border: 1px solid var(--stroke, #e7e0f1);\n  font-weight: 400;\n  padding: 10px;\n}\n\n.matrixQuestionOptionColumn {\n  width: auto;\n  border: 1px solid var(--stroke, #e7e0f1);\n}\n\n.matrixQuestionOption {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n}\n\n.matrixQuestionOptionRadio {\n  margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `AssessmentForm_dialog__Af+Dw`,
	"mainLayout": `AssessmentForm_mainLayout__ipjUr`,
	"mainLayoutInstruction": `AssessmentForm_mainLayoutInstruction__F3kgK`,
	"mainLayoutOutcomesHeader": `AssessmentForm_mainLayoutOutcomesHeader__ZwmqW`,
	"mainLayoutOutcomes": `AssessmentForm_mainLayoutOutcomes__lzhQU`,
	"mainLayoutFormHeader": `AssessmentForm_mainLayoutFormHeader__Vvmp2`,
	"mainLayoutForm": `AssessmentForm_mainLayoutForm__oExfN`,
	"form": `AssessmentForm_form__Y4rjx`,
	"formLayout": `AssessmentForm_formLayout__Wj+Pj`,
	"formLayoutBody": `AssessmentForm_formLayoutBody__7FrRX`,
	"formLayoutFooter": `AssessmentForm_formLayoutFooter__YThB3`,
	"buttonContainer": `AssessmentForm_buttonContainer__5nQJr`,
	"outcomeOnlyLayout": `AssessmentForm_outcomeOnlyLayout__9h-Oi`,
	"outcomeOnly": `AssessmentForm_outcomeOnly__Tzof-`,
	"outcomeLayout": `AssessmentForm_outcomeLayout__b9vca`,
	"outcomeCompletedLayout": `AssessmentForm_outcomeCompletedLayout__DQJUH`,
	"outcomeLayoutScore": `AssessmentForm_outcomeLayoutScore__fYFqO`,
	"outcomeLayoutOutcomeHeader": `AssessmentForm_outcomeLayoutOutcomeHeader__hY3rx`,
	"outcomeLayoutOutcomes": `AssessmentForm_outcomeLayoutOutcomes__gFimw`,
	"outcomeLayoutRemarksHeader": `AssessmentForm_outcomeLayoutRemarksHeader__g5osM`,
	"outcomeLayoutRemarks": `AssessmentForm_outcomeLayoutRemarks__fJ+Ww`,
	"outcomeLayoutFooter": `AssessmentForm_outcomeLayoutFooter__VbTlv`,
	"outcomeInput": `AssessmentForm_outcomeInput__tNJqf`,
	"outcomeOptionLayout": `AssessmentForm_outcomeOptionLayout__bpt0d`,
	"outcomeOptionLayoutCheckbox": `AssessmentForm_outcomeOptionLayoutCheckbox__lxl1k`,
	"outcomeOptionLayoutTitle": `AssessmentForm_outcomeOptionLayoutTitle__vUXKw`,
	"noMarginButton": `AssessmentForm_noMarginButton__tUpI1`,
	"ReadOnlyTextContainer": `AssessmentForm_ReadOnlyTextContainer__gAOZn`,
	"readOnlyOutcome": `AssessmentForm_readOnlyOutcome__dvYCt`,
	"scoreText": `AssessmentForm_scoreText__uUg1P`,
	"scoreTextError": `AssessmentForm_scoreTextError__2JMad`,
	"scoreTextErrorDiv": `AssessmentForm_scoreTextErrorDiv__i4-tB`,
	"submitLayout": `AssessmentForm_submitLayout__35GJK`,
	"submitLayoutDescription": `AssessmentForm_submitLayoutDescription__Un8Pk`,
	"submitLayoutLoader": `AssessmentForm_submitLayoutLoader__0wCsd`,
	"matrixQuestionTable": `AssessmentForm_matrixQuestionTable__OZJCq`,
	"matrixQuestionOptionHeader": `AssessmentForm_matrixQuestionOptionHeader__4e6Qb`,
	"matrixQuestionOptionTextColumn": `AssessmentForm_matrixQuestionOptionTextColumn__oB3B6`,
	"matrixQuestionOptionColumn": `AssessmentForm_matrixQuestionOptionColumn__RQk2w`,
	"matrixQuestionOption": `AssessmentForm_matrixQuestionOption__C5aWc`,
	"matrixQuestionOptionRadio": `AssessmentForm_matrixQuestionOptionRadio__8E2yW`
};
export default ___CSS_LOADER_EXPORT___;
